import { useMutation } from '@tanstack/react-query';

import { WorkingHoursFormSchemaValues } from 'src/features/workingHours/utils/formSchema';
import { WorkingHours } from 'src/features/workingHours/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/site-working-hours/:hoursId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: WorkingHoursFormSchemaValues;
    hoursId: string;
    siteId: string;
    parkingId: string;
}
const mutationFn = ({ hoursId, siteId, parkingId, data }: DTO): Promise<WorkingHours> => {
    return axios.put(formatResourcePath(RESOURCE, { siteId, hoursId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateWorkingHours };
